import { useEffect, useRef, useState } from "react";
import { beep, alarm } from "./sounds";

export default function useCountdown(initialSeconds = 300) {
  const [duration, setDurationState] = useState(initialSeconds);
  const [remaining, setRemaining] = useState(initialSeconds);
  const [running, setRunning] = useState(false);
  const lastBeepRef = useRef(null);

  useEffect(() => {
    if (!running) return;
    const endAt = Date.now() + remaining * 1000;
    const iv = setInterval(() => {
      const left = Math.max(0, Math.ceil((endAt - Date.now()) / 1000));
      setRemaining(left);
      if (left <= 10 && left > 0 && lastBeepRef.current !== left) {
        lastBeepRef.current = left;
        beep();
      }
      if (left <= 0) {
        clearInterval(iv);
        setRunning(false);
        alarm();
      }
    }, 250);
    return () => clearInterval(iv);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [running]);

  const setDuration = (s) => {
    setDurationState(s);
    lastBeepRef.current = null;
    if (!running) setRemaining(s);
  };
  const start = () => {
    if (remaining > 0) {
      lastBeepRef.current = null;
      setRunning(true);
    }
  };
  const pause = () => setRunning(false);
  const reset = () => {
    setRunning(false);
    setRemaining(duration);
    lastBeepRef.current = null;
  };

  return { duration, remaining, running, setDuration, start, pause, reset };
}
